// internal
import { axios, def, handleError, handleResponse } from './internal';

// state
import { storage } from '@goldblack/client-storage';

function AdminUserChangeType(userId, userType) {
    axios
        .post('/api/admin_user_changetype', {
            userId,
            userType,
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    const { user } = res.data.data;

                    let callback = (x) => x._id === userId;
                    storage.transience.updateState('search.result', callback, user);

                    storage.transience.setState('internal.success', 'The user type has been updated.');
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { AdminUserChangeType };
